export default __webpack_public_path__ + "static/media/escudoMobile.10bef5bd.svg";